<template>
  <div>
    <h3>Pelatihan Anda</h3>

    <!-- dialog user -->
    <v-dialog v-model="form.dialog" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="addItem()">
          Tambah Pelatihan Eksternal Saya
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5" v-if="form.editedIndex === -1">Tambah Pelatihan Eksternal Saya</span>
          <span class="text-h5" v-else>Lihat Data</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                class="mb-4"
                v-model="form.editedItem.kegiatan"
                :items="['PELATIHAN', 'PENINGKATAN KOMPETENSI']"
                outlined
                dense
                hide-details=""
                label="Kegiatan :"
              ></v-select>
              <v-text-field
                class="mb-4"
                v-model="form.editedItem.judul"
                outlined
                dense
                hide-details=""
                label="Judul :"
              ></v-text-field>
              <v-text-field
                class="mb-4"
                v-model="form.editedItem.tempat"
                outlined
                dense
                hide-details=""
                label="Tempat :"
              ></v-text-field>

              <v-text-field
                class="mb-4"
                type="number"
                v-model="form.editedItem.jam_pelajaran"
                outlined
                dense
                hide-details=""
                label="Jam Pelajaran :"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                type="date"
                v-model="form.editedItem.tgl_pelaksaan_awal"
                outlined
                dense
                hide-details=""
                label="Tanggal Awal :"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                type="date"
                v-model="form.editedItem.tgl_pelaksaan_akhir"
                outlined
                dense
                hide-details=""
                label="Tanggal Akhir :"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="mb-4"
                v-model="form.editedItem.link_sertifikat"
                outlined
                dense
                hide-details=""
                label="Link Sertifikat :"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveEksternalTraining()"> Simpan </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat class="">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>No</th>
              <th>Kegiatan</th>
              <th>Gambar</th>
              <th>Nama Pelatihan/ Judul</th>
              <th>Tempat</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in table.items" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>
                <v-chip color="warning" small v-if="item.id_pelatihan == -1">PELATIHAN EKSTRENAL</v-chip>
                <v-chip color="success" small v-else>PELATIHAN INTERNAL</v-chip>
                <span class="ml-2" v-if="item.id_pelatihan == -1">{{ item.kegiatan }}</span>
              </td>
              <div v-frag v-if="item.id_pelatihan == -1">
                <td></td>
                <td>{{ item.judul }}</td>
                <td>{{ item.tempat }}</td>
              </div>
              <div v-frag v-else>
                <td><v-img max-height="100" max-width="150" :src="item.gambar_url"></v-img></td>
                <td>{{ item.nama }}</td>
                <td>RSUD dr. Soeselo</td>
              </div>
              <td>
                <v-chip v-if="item.status == 'MENDAFTAR' || item.status == 'DITERIMA'" color="warning" x-small>{{
                  item.status
                }}</v-chip>
                <v-chip v-else color="success" x-small>{{ item.status }}</v-chip>
              </td>
              <td>
                <v-btn
                  v-if="item.status == 'MENDAFTAR'"
                  x-small
                  color="error"
                  @click="batalDaftar(item.id_pelatihan_peserta)"
                  class="mr-2"
                  >Batal</v-btn
                >
                <div v-else>
                  <div v-if="item.id_pelatihan == -1">
                    <a :href="item.link_sertifikat" target="_blank"
                      ><v-btn title="Lihat" x-small color="success" class=""> Lihat Sertifikat </v-btn></a
                    >
                  </div>
                  <div v-else>
                    <router-link :to="{ name: 'PesertaPelatihanDetail', params: { id: item.id } }">
                      <v-btn title="Lihat" x-small color="primary" class="mr-2"> Lihat </v-btn>
                    </router-link>
                    <v-btn v-if="item.status == 'SELESAI'" x-small color="success" @click="gotoLihatSertifikat(item.id)"
                      >Lihat Sertifikat</v-btn
                    >
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil } from '@mdi/js'
import frag from 'vue-frag'

export default {
  components: {},
  directives: {
    frag,
  },
  data() {
    return {
      icons: {
        mdiDelete,
        mdiPencil,
      },
      tableOptions: {},
      table: {
        loading: true,
        items: [],
        totalItems: 0,
      },
      form: {
        dialog: false,
        editedIndex: -1,
        editedItem: {
          id: '',
          judul: '',
          tempat: '',
          kegiatan: 'PELATIHAN',
          tgl_pelaksaan_awal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
          tgl_pelaksaan_akhir: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
          jam_pelajaran: '',
          link_sertifikat: '',
        },
        defaultItem: {
          id: '',
          judul: '',
          tempat: '',
          kegiatan: 'PELATIHAN',
          tgl_pelaksaan_awal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
          tgl_pelaksaan_akhir: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
          jam_pelajaran: '',
          link_sertifikat: '',
        },
        pembimbings: [],
      },
    }
  },
  watch: {},
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
  created() {
    this.getData()
    // this.getPembimbings()
  },
  methods: {
    getData() {
      axiosGetAuth('api/Pelatihan/getStatusPelatihanUser')
        .then(response => {
          this.table.items = response.data
          this.table.loading = false
        })
        .catch(error => {
          alert(error)
        })
    },
    batalDaftar(id_pelatihan_peserta) {
      let conf = confirm('Apakah yakin akan batal mengikuti pelatihan ini?')
      if (conf) {
        const fmData = new FormData()
        fmData.append('id_pelatihan_peserta', id_pelatihan_peserta)
        axiosPostAuth('api/Pelatihan/deletePelatihanPeserta', fmData)
          .then(response => {
            if (response.code === 200) {
              this.getData()
            } else {
              alert(response.message)
            }
          })
          .catch(error => {
            alert(error)
          })
      }
    },
    saveEksternalTraining() {
      if (this.form.editedIndex > -1) {
        const fmData = new FormData()
        fmData.append('aksi', 'update')
        fmData.append('id', this.form.editedItem.id)
        if (this.form.file_temp != '' && this.form.file_temp != undefined) {
          fmData.append('file', this.form.file_temp)
        }
        fmData.append('sort_order', this.form.editedItem.sort_order)

        axiosPostAuth('api/Pelatihan/addMateri', fmData)
          .then(response => {
            if (response.code === 200) {
              // alert(response.message)
              this.$notify({
                title: 'Pesan',
                text: response.message,
              })
              this.dialogMateri = false
              this.getAgendas()
            } else {
              alert(response.message)
            }
          })
          .catch(error => {
            alert(error)
          })
      } else {
        const fmData = new FormData()
        fmData.append('aksi', 'add')
        fmData.append('judul', this.form.editedItem.judul)
        fmData.append('tempat', this.form.editedItem.tempat)
        fmData.append('kegiatan', this.form.editedItem.kegiatan)
        fmData.append('jam_pelajaran', this.form.editedItem.jam_pelajaran)
        fmData.append('tgl_pelaksaan_awal', this.form.editedItem.tgl_pelaksaan_awal)
        fmData.append('tgl_pelaksaan_akhir', this.form.editedItem.tgl_pelaksaan_akhir)
        fmData.append('link_sertifikat', this.form.editedItem.link_sertifikat)
        axiosPostAuth('api/Pelatihan/addPelatihanEkstrenal', fmData)
          .then(response => {
            if (response.code === 200) {
              this.$notify({
                title: 'Pesan',
                text: response.message,
              })
              this.getData()
            } else {
              alert(response.message)
            }
          })
          .catch(error => {
            alert(error)
          })
      }
    },
    gotoLihatSertifikat(pelatihan_peserta_id) {
      window.open(
        `${process.env.VUE_APP_APIROOT}/Cetak/viewSertifikat/${this.$store.state.token}/${pelatihan_peserta_id}`,
        '_blank',
      )
    },
  },
}
</script>